import { asHintId, type Hint } from '@/shared/stores';

import { PATIENT_CHAT_HISTORY_ANCHOR } from './anchors';

// Anchor only mounts when there's at least one message, so empty/loading states are skipped.
export const patientChatHistoryHint: Hint = {
  id: asHintId('patient-workspace:chat-history'),
  version: 1,
  priority: 60,
  anchor: PATIENT_CHAT_HISTORY_ANCHOR,
  copy: {
    title: 'Every conversation, in one place',
    body: 'The full history between this patient and the care team — scroll up to load older messages.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
